<script setup>
defineProps({
  newEmail: {
    type: String,
  },
  chosenEmail: {
    type: String,
  },
  disabled: { type: Boolean, default: false },
})
</script>

<template>
  <div class="mx-6 flex justify-between">
    <span>
      <h3 class="text-lg font-medium">{{ $t('pref_page_email.email_title') }}</h3>
      <p class="text-sm text-gray-500">{{ newEmail ? newEmail : chosenEmail }}</p>
    </span>

    <button
      :disabled="disabled"
      type="button"
      class="rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
      @click="$emit('edit')"
    >
      {{ $t('pref_page_email.email_btn') }}
    </button>
  </div>
</template>
